export const whatsappTemplateStyles = {
  mainContainer: {
    paddingLeft: "17px",
    marginBottom: "7px",
    fontFamily: "Inter",
  },
  titleBox: {
    paddingLeft: "7px",
    fontFamily: "Inter",
    fontWeight: 600,
    color: "#566e8a",
    overflow: "hidden",
    textOverflow: "ellipsis",
    maxWidth: "100px",
  },
  titleText: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    fontSize: "13px",
    fontFamily: "Inter",
    fontWeight: 600,
    color: "#566e8a",
  },
  nodeBox: {
    display: "flex",
    flexDirection: "row",
    // alignItems: "flex-start",
    "&:hover": {
      cursor: "pointer",
    },
  },
  nodeBody: {
    // flex: 1,
    margin: 0,
    // alignSelf: "end",
    display: "flex",
    flexDirection: "row", // Change this line
    alignItems: "center",
    justifyContent: "flex-end",
    height: "60px",
    width: "120px",
    // padding: "0 10px 0 0px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#25D366",
    borderRadius: "10px",
  },
  nodeInnerBox: {
    display: "flex",
    flexDirection: "column",
    // alignItems: "center",
    marginRight: "10px",
  },
  handleBox: {
    position: "relative",
    left: "10px",
    display: "flex",
    flexDirection: "column",
    height: "60px",
    alignItems: "flex-end",
    // position: "relative",
    justifyContent: "space-evenly",
    // right: "23px",
  },
  handleInnerBox: {
    display: "flex",
    flexDirection: "row",
  },
  titleName: {
    fontSize: "10px",
    fontFamily: "Inter",
    fontWeight: 550,
  },
  nodeIcon: {
    fontSize: "16px",
    color: "#eff5fc",
    position: "relative",
    left: "13px",
    marginRight: "5px",
    "&:hover": {
      backgroundColor: "#25D366",
    },
  },
  addIcon: {
    fontSize: "6px",
    color: "#22304a",
    borderRadius: "50%",
    backgroundColor: "white",
    marginLeft: "4px",
    cursor: "pointer",
    zIndex: "9999",
    transition: "visibility 0s, color 0.2s",
    "&:hover": {
      color: "blue",
      cursor: "pointer",
    },
  },
  leftHandle: {
    background: "#566d89",
    position: "relative",
    top: "30px",
    left: "5px",
    opacity: "0",
  },
  rightHandle: {
    background: "#566d89",
    opacity: "0",
    left: "-5px",
    top: "4px",
    position: "relative",
  },
  handleText: {
    textAlign: "center",
    width: "30px",
    fontSize: "6px",
    color: "#fff",
    fontFamily: "Inter",
    marginBottom: "2px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
};
